<template>
    <div class="weeklyTarget-wrapper">
        <div class="d-flex justify-content-center align-items-center weeklyTarget-header text-center">
            <span class="backArrowIcon" id="close" @click="viewClose('someStatus')">
                <img :src='downArrow' alt="Back Arrow" /></span>
            <h2 class="m-0" v-if="!loading">
                {{ statusType === 6 ? 'Mid Night Target' : 'Weekly Target' }}
            </h2>
        </div>
        <div v-if="!loading">
            <div v-if="statusType !== 6">
                <WeeklyTarget />
            </div>
            <div v-else>
                <MidnightTarget />
            </div>
        </div>
        <div v-else class="text-center p-4">
            <p>Loading...</p>
        </div>
    </div>

</template>
<script>
import { viewClose as androidViewClose } from '@/utils/android';
import axios from 'axios';
import downArrow from '../../assets/images/back-blackArrow.svg';
import WeeklyTarget from './WeeklyTarget.vue'
import MidnightTarget from './MidnightTarget.vue'
export default {
    name: 'TargetComponent',
    components: {
        WeeklyTarget,
        MidnightTarget
    },
    data() {
        return {
            statusType: null,
            loading: true,
            downArrow,
        }
    },
    mounted() {
        this.fetchTargetStatusData();
    },
    methods: {
        async fetchTargetStatusData() {
            try {
                const tokenParam = this.$route.params.token;
                const token = tokenParam.split("=")[0];
                const apiUrl = `api/freetarget-weekly`;
                const response = await axios.get(apiUrl, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                this.statusType = response.data.status;
            } catch (error) {
                console.error("Error fetching target status:", error);
            } finally {
                this.loading = false; // stop loader after API call
            }
        },
        // Close Webview on back arrow click
        viewClose(status) {
            if (window.Android && typeof window.Android.viewClose === "function") {
                androidViewClose(status);
            } // iOS interface via messageHandlers
            else if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.viewClose) {
                window.webkit.messageHandlers.viewClose.postMessage("close");
            } else {
                window.parent.postMessage({ action: "closePopup", status }, "*");
            }
        }
    }
}
</script>